<template>
  <div v-if="content && content.comment"  class="mt-3 mb-5">
    <div class="clearfix my-2">
      <div class="float-left bolder">작성자: {{content.name}}</div>
      <div class="float-right clock"><mdb-icon icon="clock"/> {{$strDate(content.regDate)}}</div>
    </div>
    <div v-html="$linebreak(content.comment)"></div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
export default {
  name: 'ProceedingCommentView',
  props: ['content']
}
</script>
